import { Grid,makeStyles}              from '@material-ui/core';
import React                           from 'react';

const useStyles =  makeStyles (theme =>({
    ContenedorLectura:{
        width:'502px',
                  [theme.breakpoints.down(502)]:{
            width:'350px',
            padding: '60px 0 0 0',
        },
        [theme.breakpoints.down(350)]:{
            width:'300px',
            padding: '30px 0 0 0',
        },
    },
    ContainerTitulo:{
        margin:'0 0 34px 0',
        '& .Titulo':{
            letterSpacing: '0px',
            color: '#EEA90A',
            margin:'0',
            textAlign:'center',
            font:'43px fredoka one',
            lineHeight:'52px',
            [theme.breakpoints.down(502)]:{
                font:'30px fredoka one',
                lineHeight:'32px',
            },
            [theme.breakpoints.down(350)]:{
                font:'28px fredoka one',
                lineHeight:'32px',
            },
        },
    },
    Parrafo1:{
        margin:' 0 0 36px 0',
        '& .Lectura':{
            margin:'0 0 36px 0',
            color:'#000',
            font:'18px lato',
            lineHeight :'28px',
            letterSpacing: '0.17px',
            [theme.breakpoints.down(502)]:{
                font:'16px lato',
                lineHeight :'21px',
                letterSpacing: '0.09px',
            },
            [theme.breakpoints.down(350)]:{
                font:'12px lato',
                lineHeight :'17px',
                letterSpacing: '0.09px',
            },
        },
        '& .TextImg':{
            color:'#717476',
            font:' 16px lato',
            lineHeight :'25px',
            letterSpacing: '0.15px',
            margin:'0',
            [theme.breakpoints.down(502)]:{
                font:' 11px lato',
                lineHeight :'14px',
                letterSpacing: '0.10px',
            },
        },

        '& .Imagen':{
            width:'100%',
        },  
      
    }
}));

const El_mejor_cazador = () => {
const classes = useStyles ()
    return (  
        <Grid container item justifyContent="center" xs={12} className={classes.Contenedor}>
            <Grid container item className={classes.ContenedorLectura} justifyContent="center">
                <Grid container item sm={12} className={classes.ContainerTitulo} justifyContent="center">
                    <h2 className="Titulo" >
                        El mejor cazador
                    </h2>
                </Grid>
                <Grid container item sm={12} className={classes.Parrafo1} justifyContent="center">
                    <Grid container sm={12}>
                      <p className="Lectura">
                        En el mundo animal, los depredadores son animales que cazan a otros para 
                        alimentarse. Los felinos son depredadores que utilizan sus garras y colmillos para 
                        defenderse y también para cazar y obtener alimento, pero ¿cuál de ellos es el mejor 
                        cazador? <br/><br/>
                        
                        El guepardo, en primer lugar, es uno de los animales más rápidos sobre la tierra, lo 
                        que lo vuelve un cazador muy hábil. Pero, por ser esbelto y pequeño, resulta una 
                        presa fácil para depredadores más grandes. <br/><br/>
                        
                        El tigre, en segundo lugar, es otro depredador que puede cazar casi cualquier animal 
                        que desee, ya que es sumamente fuerte. Pero, al ser un cazador solitario, puede 
                        encontrarse en problemas al enfrentarse con un animal más grande que él, como un 
                        oso o un elefante.
                      </p>
                    </Grid>
                    <Grid container justifyContent="center" sm={12}>
                        <Grid container justifyContent="center" >
                            <img className="Imagen" src="https://img-lecturas-cdl.s3.us-west-1.amazonaws.com/Imagenes+Lecturas/Img1ro/Sesion42/1.png" alt="Tarjeta" />
                        </Grid>
                        <Grid container justifyContent="center" >
                            <p className="TextImg">
                                El guepardo y el tigre son excelentes cazadores.
                            </p>
                        </Grid>
                    </Grid>
                </Grid>
                <Grid container item sm={12} className={classes.Parrafo1} justifyContent="center">
                    <Grid container sm={12}>
                      <p className="Lectura">
                        Aunque te parezca extraño, el gato doméstico supera a ambos 
                        en ferocidad. A diferencia de aquéllos, que cazan para obtener
                        alimento, un gato lo hace por diversión y muy raramente con el 
                        objetivo de alimentarse. Además, no se fija demasiado en el 
                        tamaño de sus presas. Incluso, si su dueño lo hace enojar, no 
                        dudará en defenderse.<br/><br/> 
                    
                        Así que, aunque sea una mascota popular y tierna, no hay que 
                        olvidar que sigue siendo un depredador y que podría comportarse 
                        como tal.
                      </p>
                    </Grid>
                    <Grid container justifyContent="center" sm={12}>
                        <Grid container justifyContent="center" >
                            <img className="Imagen" src="https://img-lecturas-cdl.s3.us-west-1.amazonaws.com/Imagenes+Lecturas/Img1ro/Sesion42/2.png" alt="Tarjeta" />
                        </Grid>
                        <Grid container justifyContent="center" >
                            <p className="TextImg">
                            El gato doméstico caza por diversión.
                            </p>
                        </Grid>
                    </Grid>
                </Grid>
        </Grid>
    </Grid>
    );
}
 
export default El_mejor_cazador ;
